import {ProductList, Nameml} from "App/services/api";
import {FetchAction, FetchState} from "App/services";
import {ActionType, Language} from "App/constants";
import {List} from 'immutable';
import {selectedGlobalLang} from "App/helper";

export interface Filter {
    id: number;
    position: number;
    name: Nameml;
    unit: string
    min: number;
    max: number;
    step: number;
    actualMin: number
    actualMax: number
}

export interface State {
    subId: number
    product: ProductList
    filters: List<Filter>
    showFilters: boolean
}

function notEmpty<T>(value: T | null | undefined): value is T {
    return value !== null && value !== undefined;
}

export function extractNumber(value:string): number | null {
    const matches: string[] | null = value.replace(/[\']/,'').match(/[+-]?\d+(?:(,|\.)\d+)?/g);
    const numbers: number[] = matches&&matches.map(i => i.replace(/\,/g, '.')).map(Number)||[];
    return numbers.length==1?numbers[0]:null;
}

function extractUnit(value:string): string {
    return value.
    replace(/[\']/,'').
    replace(/[+-]?\d+(?:(,|\.)\d+)?/g, '').trim();
}

function extractFilter(products: ProductList, position: number): Filter | null {
    // Find min-max
    const numbers: number[] = products.map(p => p['maincharacteristic'+position+'value']&&extractNumber(p['maincharacteristic'+position+'value'])).filter(notEmpty);
    if (!numbers.length || numbers.length!==products.length) {
        return null;
    }
    const min: number = Math.floor(Math.min( ...numbers )), max: number = Math.ceil(Math.max( ...numbers ));
    if (min===null || max===null || min>=max) return null;
    // Get unit
    const unit: string = extractUnit(products[0]['maincharacteristic'+position+'value']);
    // Get id
    const ids: number[] = products.map(p => p['maincharacteristic'+position+'id']).filter(notEmpty);
    if (!ids.length||!ids.every(e => e===ids[0])) return null;
    const id: number = ids[0];
    // Get label
    const language: Language = selectedGlobalLang();
    const names: string[] = products.map(p => p['maincharacteristic'+position+'nameml']&&p['maincharacteristic'+position+'nameml'][language]).filter(notEmpty);
    if (!names.length||!names.every(e => e===names[0])) return null;
    const name: Nameml = products[0]['maincharacteristic'+position+'nameml'];
    // Get step
    const step: number = max-min?1/Math.pow(10,2-Math.round(Math.log10(max-min))):1;
    // Done
    return {id, position, min, max, step, name, unit, actualMin: min, actualMax: max};
}

function extractFilters(products: ProductList): List<Filter> {

    const slider1: Filter | null = extractFilter(products, 1);
    const slider2: Filter | null = extractFilter(products, 2);
    const slider3: Filter | null = extractFilter(products, 3);
    return List<Filter>([slider1,slider2,slider3].filter(notEmpty));
}

export function reducer(state: State | null = null, action: FetchAction) {
    switch (action.type) {
        case ActionType.FETCH_PRODUCTSBYFAMILYICONS: {
            switch (action.state) {
                case FetchState.SUCCESS: {
                    const productList: ProductList = action.payload;
                    const filters: List<Filter> =  extractFilters(productList);
                    return {
                        subId: <number>action.params,
                        product: productList,
                        filters: filters,
                        showFilters: productList.length>4
                    }
                }
                default:
                    return state;
            }
        }
        case ActionType.FILTER_PRODUCTS: {
            let filters: List<Filter> = (state&&state.filters||List<Filter>());
            const index: number = filters.findIndex(f => f.id===action.payload.id);
            if (index>=0) {
                const filter: Filter | undefined = filters.get(index);
                if (filter) {
                    filter.actualMin = action.payload.value[0];
                    filter.actualMax = action.payload.value[1];
                    filters = filters.remove(index);
                    filters = filters.insert(index, filter);
                }
            }
            return {
                ...state,
                filters
            }
        }
        case ActionType.TOGGLE_FILTER: {
            return {
                ...state,
                showFilters: state&&!state.showFilters
            }
        }
        case ActionType.PAGE_MAIN: {
            return null;
        }
        case ActionType.PAGE_CATEGORY: {
            return null;
        }
        default:
            return state
    }
}

export function changeSubCategoryPageFilter(id:number, value:[number,number]): any {
    return {
        type: ActionType.FILTER_PRODUCTS,
        payload: {id, value}
    }
}

export function toggleFilter(): any {
    return {
        type: ActionType.TOGGLE_FILTER
    }
}



// WEBPACK FOOTER //
// ./src/services/reducers/products.ts